var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3",attrs:{"data-aos":"fade-in","data-aos-easing":"ease-in-out","data-aos-duration":"500"}},[_c('div',{staticClass:"grid xl:grid-cols-2 gap-x-5 grid-cols-1 gap-y-5 mt-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }